<template>
  <v-row>
    <v-col>
      <v-container pb-4 grid-list-xl>
        <v-layout row wrap class="user-detailboxmain fixed-depositbox">
          <v-flex class="user-detailbox">
            <v-list-item v-for="savingDetail in savingAccountData" :key="savingDetail.id">
              <v-list-item-content>
                <v-list-item-title>
                  <h3 v-if="savingDetail.name">{{savingDetail.name}}</h3>
                  <h3 v-else>Account Owner Name(N/A)</h3>
                </v-list-item-title>
                <v-list-item-subtitle v-for="savingAccounts in savingDetail.description" :key="savingAccounts.id">
                  <div class="account-detailbox">
                      <div class="bank-name">
                        <h5 v-if="savingAccounts.bank_name">{{savingAccounts.bank_name}} <span v-if="savingAccounts.account_type =='2'">(Post Office)</span></h5>
                        <h5 v-else>Bank Name(N/A)</h5>
                        <p v-if="savingAccounts.account_no">{{savingAccounts.account_no}}</p>
                        <p v-else>Account No.(N/A)</p>
                      </div>
                      <div class="amount-box">
                        <v-col class="memberbox-editbox">
                            <v-menu bottom left offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  outlined fab
                                  color="#F19700"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="showHide(savingAccounts['form_id'])"
                                  v-if="allow_user_activity =='yes'"
                                >
                                  <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                </v-btn>
                              </template>
                              <v-list v-if="(hideShowId == savingAccounts['form_id'])">
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="editAccounts(savingAccounts['form_id'])">
                                      <v-img
                                      max-height="20"
                                      max-width="20"
                                      :src="edit_pic"
                                      :lazy-src="edit_pic"
                                      ></v-img> Edit
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="deleteAccounts(savingAccounts['form_id'])">
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" delete_pic"
                                      :lazy-src=" delete_pic"
                                      > </v-img>Delete
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                        <span>Amount Invested on {{savingAccounts.start_date}}
                        </span>
                        <p><span> &#8377;</span> {{savingAccounts.amount_invested}}</p>
                      </div>
                  </div>
                  <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Maturity Date</span>
                        <p v-if="savingAccounts.maturity_date">{{savingAccounts.maturity_date | moment("DD MMM, YYYY")}}</p>
                        <p v-else>N/A</p>
                      </div>
                      <div class="amount-box">
                        <span v-if="savingAccounts.is_matured == 'MATURED'">Balance on {{savingAccounts.maturity_date | moment("DD MMM, YYYY")}} </span>
                        <span v-else>Balance on {{currentDate | moment("DD MMM, YYYY")}}
                        </span>
                        <p v-if="savingAccounts.is_matured == 'MATURED'"><span> &#8377;</span> {{savingAccounts.maturity_amount}} </p>
                        <p v-else><span> &#8377;</span> {{savingAccounts.current_balance}}</p>
                      </div>
                  </div>
                  <div class="maturity-Datebox Rate-of-Interest">
                      <div class="bank-name">
                        <span>Rate of Interest</span>
                        <p v-if="savingAccounts.interest_rate">{{savingAccounts.interest_rate}}%</p>
                        <p v-else>N/A</p>
                      </div>
                      <div class="amount-box">
                        <span>
                        Maturity Amount on {{savingAccounts.maturity_date | moment("DD MMM, YYYY")}}   
                        </span>
                        <p><span> &#8377;</span> {{savingAccounts.maturity_amount}}</p>
                      </div>
                  </div>
                  <div class="maturity-Datebox">
                    <div class="bank-name">
                      <span>Joint Account Owner</span>
                      <p v-if="savingAccounts.joint_account_owner">{{savingAccounts.joint_account_owner}}</p>
                      <p v-else>N/A</p>
                    </div>
                    <div class="" v-if="savingAccounts.maturity_date && savingAccounts.is_matured == 'MATURED'">
                      <span style="color:#FF0000;"><b>{{savingAccounts.is_matured}}</b></span>
                    </div>
                  </div>
                  <div class="maturity-Datebox">
                    <div class="bank-name">
                      <label>Investment Goal</label>
                      <v-select
                        name="cap"
                        :v-model="cap"
                        :items="capList"
                        item-value="type"
                        item-text="name"
                        @change="updatFormCap(savingAccounts['form_id'], $event)"
                        bg-color="red"
                        placeholder="Please select your options"
                        class="inline select-box"
                        :value="savingAccounts['saving_type']"
                        outlined

                        style="width:400px; border-width:2px;"
                      ></v-select>
                      
                    </div>
                    <div class="amount-box">
                      <span>Nominee/s</span>
                      <p v-if="savingAccounts.nominee.length != 0">
                      <span v-for="(items,index) in savingAccounts.nominee">{{items}}<span v-if="savingAccounts.nominee.length > index+1">, </span></span>
                        </p>
                      <p v-else>N/A</p>
                    </div>
                  </div>
                </v-list-item-subtitle> 
              </v-list-item-content>  
            </v-list-item>
          </v-flex>
        </v-layout>  
      </v-container>  
      <div class="total-amount-box" v-if="savingAccountData.length != 0">
          <h4>Total Fixed Deposit Balance</h4>
          <div class="total-amount">
            <span>As on {{currentDate | moment("DD MMM, YYYY")}}</span>
            <p><span> &#8377;</span> {{amount.toLocaleString()}}</p>
          </div>
      </div>
      <div v-else>
        <v-list-item>
          <div class="user-detailbox">
            <v-list-item-content>
              <div class="text-h5 mb-1">
                No data found.
              </div>
            </v-list-item-content>
          </div>
        </v-list-item>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { Auth } from "aws-amplify";
  import { GET_DEPOSIT_DATA, DELETE_DEPOSIT_DATA } from "../../store/actions.type";
  import JwtService from ".././common/jwt.service";
  import { isEmpty } from 'lodash';
  import axios from "axios";
  
  export default {
    data () {
      return {
       three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
       currentDate: new Date().setDate(new Date().getDate()),
       //amount:0,
       //savingAccountData:'',
       edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
       delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
       hideShow:false,
       hideShowId:'',
       full_name:'',
       allow_user_activity:localStorage.getItem('allow_user_activity'),
       capList:[{"type":"Saving for Retirement","name":"Saving for Retirement"},{"type":"Saving to fund Children's Education","name":"Saving to fund Children's Education"},{"type":"Saving for a vacation","name":"Saving for a vacation"},{"type":"Buying a home","name":"Buying a home"},{"type":"Starting a business","name":"Starting a business"},{"type":"Building an emergency fund","name":"Building an emergency fund"},{"type":"Paying of debt","name":"Paying of debt"},{"type":"Pre payment of Home Loan","name":"Pre payment of Home Loan"}],

      cap:''
     }
    },
    created(){
      Fire.$on("loadData", () => {
        this.savingAccountList();
      });
    },
    mounted () {
      if(this.isDataEmpty) this.savingAccountList();  
    },
   computed: {
      
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.allDepositData);
      },
      savingAccountData: function () {
        return !this.isDataEmpty ? this.$store.getters.allDepositData.data.fixed_account_detail : [];
      },
      amount: function () {
        let amount = 0;
        this.$store.getters.allDepositData.balaces_details.balances.forEach(details => {
          if(details.acoount_type == 'Fixed Deposits')
          {
            amount +=  parseInt(details.balance);
          }
        })
        return amount;
      }
    },
    
    methods:{
     showHide(id){
        this.hideShowId = id;
        this.hideShow = this.hideShow ? false : true;
      },
      showHideAgain(id){
        if (this.hideShow == true) {
          //this.hideShow = false; 
        }

          //this.hideShow = true;

      },
      editAccounts(editId){
        this.$router.push({ path: "/edit-fixed-deposit/"+btoa(editId)}).catch(()=>{});
      },
      deleteAccounts(id){
        swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let user_name =  this.$store.getters.getUserDetails.user_name;
            this.$store.dispatch(DELETE_DEPOSIT_DATA, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:id,
              },
              api: "delete-form",
            })
             .then(() => {
              this.savingAccountList();
              Toast.fire({
                icon: 'success',
                title: 'Data deleted successfully.'
              })
            });

           } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
      savingAccountList(){
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$loading(true);
        this.$store.dispatch(GET_DEPOSIT_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-user-form-detail",
        })
        .then(() => {
            Fire.$emit("updateAllDepositData");
            this.$loading(false);
        }).catch(() => {
           this.$loading(false);
        });
      },

      updatFormCap(id, saving_type){
        let formdata = new FormData();
        formdata.append("form_id", id);
        formdata.append("saving_type", saving_type);
        axios
          .post(process.env.VUE_APP_ROOT_API + "update-user-form-saving-type", formdata)
          .then((res) => {
            // swal.fire({
            //   title: "Saving Type Updated Successfully",
            //   icon: "success",
            // });
          })
          .catch(() => {});
      }
    }
  }
</script>
